/* 
    Importing Dependencies
*/
import * as service from "../../Service/Service";

export default {
  name: "Search",

  data: () => ({
    isLoading: false,
    ProvinceCityList: [],
    provincesList: [],
    cityList: [],
    selectedProvince: "",
    selectedCity: "",
    details: [],
    filteredProvinceDetails: [],
    headers: [
      {
        text: "BRANCH NAME",
        sortable: true,
        value: "BRANCH NAME"
      },
      { text: "Status", value: "Status" },
      { text: "Edit", value: "actions" }
    ],
    snackbar: {
      isActive: false,
      text: "",
      color: "",
      timeout: 2000
    },
    search: "",
    isEditDetails: false,
    branchDetails: {},
    rules: {
      required: value => !!value || "Please enter the status",
      confirmRequired: value => !!value || "Please re-enter the Branch Code"
    }
  }),

  async mounted() {
    await this.GetprovinceAndCity();
  },

  methods: {
    async GetprovinceAndCity() {
      let context = this;
      this.isLoading = true;
      let result = await service.GetProvinceAndCity();
      if (result.error == false) {
        this.ProvinceCityList = result.data;
        context.provincesList = result.data.map(x => x.ProvinceName);
        //
      } else {
        this.snackbar.isActive = true;
        this.snackbar.text = "Something went wrong, please try again";
        this.snackbar.color = "warning";
      }
      this.isLoading = false;
    },

    async GetBranchDetails() {
      this.isLoading = true;
      let result = await service.GetBranchDetails(
        this.selectedProvince,
        this.selectedCity
      );
      if (!result.error) {
        this.details = result.data;
        console.log(this.details);

        //this.filteredProvinceDetails = result.data;
      } else {
        this.snackbar.isActive = true;
        this.snackbar.text = "Something went wrong, please try again";
        this.snackbar.color = "warning";
      }
      this.isLoading = false;
    },

    FilteredCityList() {
      let cities = this.ProvinceCityList.filter(
        x => x.ProvinceName == this.selectedProvince
      )[0].City;

      if (cities.length == 0) {
        return false;
      } else {
        this.cityList = cities;
      }
    },

    EditBranchDetails(item) {
      this.branchDetails = Object.assign({}, item);
      this.isEditDetails = true;
    },

    async UpdateBranchStatus() {
      var result = this.$refs.form.validate();
      if (result) {
        let model = {
          ID: this.branchDetails.ID,
          Status: this.branchDetails.Status
        };
        this.isLoading = true;
        var response = await service.UpdateBranchDetails(model);
        if (!response.error) {
          this.details.filter(
            x => x.ID == this.branchDetails.ID
          )[0].Status = this.branchDetails.Status;
          this.snackbar.isActive = true;
          this.snackbar.color = "success";
          this.snackbar.text = "Status updated successfully";
        } else {
          this.snackbar.isActive = true;
          this.snackbar.text = "Something went wrong, please try again";
          this.snackbar.color = "warning";
        }
        this.isLoading = false;
        this.isEditDetails = false;
      }
    }
  }
};
